import type { CampaignConfig, Lead } from '../types';

const FIELDS: Array<[string, string]> = [
  ['title', 'c2'], ['first_name', 'c2'], ['middle_initial', 'c2'],
  ['last_name', 'c3'], ['gender', 'c3'],
  ['address1', 'c3'], ['address2', 'c3'],
  ['address3', 'c2'], ['city', 'c2'], ['state', 'c2'],
  ['postal_code', 'c2'], ['province', 'c2'], ['vendor_lead_code', 'c2'],
  ['phone_number', 'c3'], ['alt_phone', 'c3'],
  ['email', 'c3'], ['security_phrase', 'c3'],
];

export function LeadForm({ lead, config }: { lead: Lead | null; config: CampaignConfig | null }) {
  const label = (f: string) => config?.screen_labels[f] ?? f.replace(/_/g, ' ');
  const val = (f: string) => (f === 'phone_number' ? lead?.phone_number ?? '' : String(lead?.data[f] ?? ''));
  return (
    <form id="user-form" onSubmit={(e) => e.preventDefault()}>
      {FIELDS.map(([f, c]) => (
        <div key={f} className={c}><label>{label(f)}</label><input readOnly value={val(f)} /></div>
      ))}
      <div className="c6"><label>{label('comments')}</label><textarea readOnly rows={3} value={String(lead?.data['comments'] ?? '')} /></div>
      <div className="c6" style={{ fontSize: 12, color: 'var(--muted)' }}>
        lead_id {lead?.lead_id ?? '—'} · list_id {lead?.list_id ?? '—'} · attempts {lead?.attempts ?? '—'} · last {lead?.last_disposition ?? '—'}
      </div>
    </form>
  );
}
